import React from "react";
import { Provider } from "react-redux";

import store from "./store";
import Alert from "./components/Alert";

const RPAProvider = ({ children }) => (
  <Provider store={store}>
    <Alert />
    {children}
  </Provider>
);
export default RPAProvider;
